import React, { useEffect, useState } from "react";
import * as ReactDOMClient from "react-dom/client";
import { getNavigationInfo } from "@/common/api/Services/Auth";
const Header = () => {
    const [loginStatus, setLoginStatus] = useState("loading");
    const [isHidePremium, setIsHidePremium] = useState(true);
    useEffect(() => {
        (async () => {
            try {
                const navigationInfo = await getNavigationInfo();
                setIsHidePremium(navigationInfo.isHidePremium);
                if (navigationInfo.isLoggedIn) {
                    setLoginStatus("loggedIn");
                    return;
                }
                setLoginStatus("loggedOut");
            }
            catch (error) {
                console.warn(error);
                setLoginStatus("loggedOut");
            }
        })();
    }, []);
    const handleClick = (event) => {
        if (event.currentTarget.parentElement) {
            event.currentTarget.parentElement.classList.toggle("show-menu");
        }
    };
    const navigation = window.location.pathname;
    const isShowPremiumLink = !isHidePremium;
    return (React.createElement("header", { className: 'mvm-rd-font position-relative' },
        React.createElement("div", { className: 'container-fluid navbar navbar-expand-lg navbar-light' },
            React.createElement("ul", { className: "nav" },
                React.createElement("div", { className: "hamburger", onClick: handleClick },
                    React.createElement("span", null, "\u00A0"),
                    React.createElement("span", null, "\u00A0"),
                    React.createElement("span", null, "\u00A0")),
                React.createElement("a", { href: "/", className: 'header-logo' },
                    React.createElement("img", { src: '/public/images/svgs/header-logo.svg', alt: "MVM logo" })),
                React.createElement("li", { className: navigation === "/why-virtual-fitness"
                        ? "nav-item active"
                        : "nav-item" },
                    React.createElement("a", { className: "nav-link", href: "/why-virtual-fitness" }, "Why virtual fitness?")),
                React.createElement("li", { className: navigation === "/how-it-works"
                        ? "nav-item active"
                        : "nav-item" },
                    React.createElement("a", { className: "nav-link", href: "/how-it-works" }, "How it works")),
                React.createElement("li", { className: navigation === "/pricing"
                        ? "nav-item active"
                        : "nav-item" },
                    React.createElement("a", { className: "nav-link", href: "/pricing" }, "Pricing")),
                React.createElement("li", { className: "nav-item" },
                    React.createElement("a", { className: "nav-link", target: "_blank", href: "https://mvmhelp.myvirtualmission.com/en/" }, "Help")),
                React.createElement("li", { className: navigation === "/contact"
                        ? "nav-item active"
                        : "nav-item" },
                    React.createElement("a", { className: "nav-link", href: "/contact" }, "Contact")),
                loginStatus === "loggedIn" && (React.createElement(React.Fragment, null,
                    isShowPremiumLink && (React.createElement("li", { className: "nav-item d-xl-none d-lg-none d-md-none" },
                        React.createElement("a", { className: "nav-link", href: "/get-premium" }, "Get premium"))),
                    React.createElement("li", { className: "nav-item d-xl-none d-lg-none d-md-none" },
                        React.createElement("a", { className: "nav-link", href: "/missions/start-mission" }, "Start a mission")),
                    React.createElement("li", { className: "nav-item d-xl-none d-lg-none d-md-none" },
                        React.createElement("a", { className: "nav-link", href: "/connections" }, "My connections")),
                    React.createElement("li", { className: "nav-item d-xl-none d-lg-none d-md-none" },
                        React.createElement("a", { className: "nav-link", href: "/events" }, "The Conqueror")),
                    React.createElement("li", { className: "nav-item d-xl-none d-lg-none d-md-none" },
                        React.createElement("a", { className: "nav-link", href: "/default/settings" }, "My settings")),
                    React.createElement("li", { className: "nav-item d-xl-none d-lg-none d-md-none" },
                        React.createElement("a", { className: "nav-link", href: "/logout" }, "Logout")))),
                React.createElement("li", { className: "nav-item" },
                    React.createElement("a", { className: "btn btn-primary btn-dark-blue", "aria-current": 'page', href: loginStatus === "loggedIn"
                            ? "/default/profile"
                            : "/default/login" }, loginStatus === "loggedIn"
                        ? "My Missions"
                        : "Log In"))))));
};
export { Header };
const rctHeader = document.getElementById("rct-header");
if (rctHeader !== null) {
    ReactDOMClient.createRoot(rctHeader).render(React.createElement(Header, null));
}
